import React from "react";
import { connect } from "react-redux";
import CrewLineup from "./CrewLineup";
//import GoToMultiplayerLobbyLink from './GoToMultiplayerLobbyLink'
import LobbyCTA from "./LobbyCTA";
import EditCombatantModal from "../b5-crew-management/EditCombatantModal.js";
import { goToQuickBattle } from "./get-home-menu-options";
import "./b5-menus.css";
//import MenuHeader from './MenuHeader'
import CrewHomeInviteModal from "./CrewHomeInviteModal";
import EditCrewNameModal from "./EditCrewNameModal"
import AudioControl from '../_audio/AudioControl.js'
import audioManager from '../_audio/audio-manager'
import MenuBrandingLogo from './MenuBrandingLogo'
import HomeEmailModal from './HomeEmailModal'

class CrewHome extends React.Component {
  constructor() {
    super();
    this.state = {
      isInviteModalOpen: false,
      isQuickBattleButtonPressed: false
    };
  }

  componentDidMount() {
    //Play the music!
    audioManager.playSong("music_b5Menu");
  }

  handleQuickBattle() {
    this.setState({
      isQuickBattleButtonPressed: true
    }, () => {
      audioManager.stopSong();
      audioManager.playSfx("sfx_acceptBattle")
      setTimeout(() => {
        goToQuickBattle();
      }, 1400)
    })
  }

  handleOpenInviteModal() {
    this.setState({ isInviteModalOpen: true });
  }
  handleCloseInviteModal() {
    this.setState({ isInviteModalOpen: false });
  }

  /* Open the modal if Editing Modal is open */
  renderInviteModal() {
    if (this.state.isInviteModalOpen) {
      return (
        <CrewHomeInviteModal
          handleCloseCallback={this.handleCloseInviteModal.bind(this)}
        />
      );
    }
    return null;
  }

  /* Open the modal if Editing Modal is open */
  renderEditCombatantModal() {
    if (this.props.editingCombatantProperties.isActivated) {
      return <EditCombatantModal />;
    }
    return null;
  }

  /* Show Crew Name modal if we're editing Crew Name */
  renderEditCrewNameModal() {
    if (this.props.isCrewNameModalOption) {
      return <EditCrewNameModal />;
    }
    return null;
  }

  renderOptinModal() {
    if (this.props.isHomeEmailModalOpen) {
      return <HomeEmailModal/>
    }
    return null
  }

  //Maybe return styles that wrap the desktop layout together
  getDesktopWrap() {
    if (this.props.viewportMode === "portrait") {
      return {};
    }
    return {
      width: "45em",
      margin: "0 auto"
    };
  }

  getCenterSectionPaddingTop() {
    return (this.props.viewportMode === "portrait")
      ? this.props.vH * 3 //mobile
      : this.props.vH * 5; //desktop
  }

  renderQuickBattleButton() {
    if (this.state.isQuickBattleButtonPressed) {
      return (
        <LobbyCTA
          text="Battle Accepted!"
          handler={this.handleQuickBattle}
          isReadyPressed={true}
          isDisabled={true}
        />
      )
    }
    return (
      <LobbyCTA
        text="Quick Battle"
        handler={this.handleQuickBattle.bind(this)}
        isPrimary={true}
      />
    )
  }

  render() {
    const { viewportMode /*vW*/ } = this.props;

    const style = {
      fontSize: viewportMode === "portrait" ? "0.6em" : "0.45em", //mobile, desktop
      height: "100%"
    };

    return (
      <div style={{ height: "100%" }}>
        <div style={style} className="page-container menu-texture">
          <MenuBrandingLogo />
          {/* Middle section */}
          <div
            className="page-container--section center-section"
            style={{
              paddingBottom: "1em",
              paddingTop: this.getCenterSectionPaddingTop(),
              ...this.getDesktopWrap()
            }}
          >
            <CrewLineup
              showLaptop={true}
              showViewRecordButton={this.props.logggedInUserId}
              crewTeamModel={this.props.crewMembers}
              areCombatantsEditable={true}
              crewName={this.props.crewName}
            />
          </div>

          {/* Bottom, CTA section */}
          <div
            className="page-container--section"
            style={{ padding: "2em 2em 3em", ...this.getDesktopWrap() }}
          >
            {this.renderQuickBattleButton()}
            <LobbyCTA
              text="Invite Friends"
              handler={this.handleOpenInviteModal.bind(this)}
              isPrimary={false}
            />
          </div>
        </div>

        {this.renderEditCrewNameModal()}
        {this.renderEditCombatantModal()}
        {this.renderInviteModal()}
        {this.renderOptinModal() }

        <AudioControl />
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    //someProp: state.something.someProp
    vW: state.global.vW,
    vH: state.global.vH,
    viewportMode: state.global.viewportMode,

    logggedInUserId: state.crew.logggedInUserId,
    crewName: state.crew.name,
    crewMembers: state.crew.members,
    editingCombatantProperties: state.matchmaking.editingCombatantProperties,

    isCrewNameModalOption: state.matchmaking.isCrewNameModalOption,
    isHomeEmailModalOpen: state.global.isHomeEmailModalOpen
  };
})(CrewHome);



// WEBPACK FOOTER //
// ./src/b5-home/CrewHome.js